import * as React from 'react';
import { Box, ChakraProvider, Drawer, DrawerContent, useDisclosure } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import Sidebar from "./components/layout/Sidebar";
import Header from "./components/layout/Header";
import theme from './theme';
import { AuthProvider } from "./features/auth/services/authService";

const App: React.FC = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <AuthProvider>
        <ChakraProvider theme={theme}>
            {/* Sidebar fixée pour desktop */}
            <Box display={{ base: 'none', md: 'block' }}>
                <Sidebar />
            </Box>

            {/* Drawer pour mobile */}
            <Drawer
                isOpen={isOpen}
                placement="left"
                onClose={onClose}
                returnFocusOnClose={false}
                size="full"
            >
                <DrawerContent>
                    <Sidebar onClose={onClose} />
                </DrawerContent>
            </Drawer>

            {/* Layout principal */}
            <Box id="root" display="flex" flexDirection="column" minHeight="100vh" ml={{ base: 0, md: '240px' }}>
                {/* Header (passer onOpen pour ouvrir le Drawer en mode mobile) */}
                <Header onOpen={onOpen} />
                <Box as="main" pt="80px" p="4" bgColor="#ededed">
                    <Outlet />
                </Box>
            </Box>
        </ChakraProvider>
            </AuthProvider>
                );
};

export default App;
